import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      buttons: {
        submitAudit: true,
      },
      buttonText: {
        submitAudit: '暂存',
      },
      formFunctionCode: 'main_form',
    };
  },
  async created() {
    await this.getFormRule('main_form', 'CRM20250626000000004');
  },
  methods: {
    // 设置规则
    setRule(item) {
      const rowData = item;
      console.log(rowData);
      if (rowData.field === 'fileList') {
        rowData.props = {
          ...rowData.props,
          showFileList: true,
          uploadType: 'file',
          listType: 'text',
          fileMsg: '只能上传/png/jpg文件',
          accept: '.png,.jpg',
        };
      }

      if (rowData.field === 'contactPersonPhone') {
        rowData.props = {
          ...item.props,
          maxlength: '11',
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^1[3-9][0-9]{9}$',
            message: '手机号格式不准确',
          },
        ];
      }
      if (rowData.field === 'yearTurnover') {
        rowData.props = {
          ...item.props,
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^[1-9][0-9]*$',
            message: '年销售额为正整数',
          },
        ];
      }
      if (rowData.field === 'registeredCapital') {
        rowData.props = {
          ...item.props,
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^[1-9][0-9]*$',
            message: '注册资金为正整数',
          },
        ];
      }
      if (rowData.field === 'yearAlcoholTolerance') {
        rowData.props = {
          ...item.props,
        };
        rowData.validate = [
          ...item.validate,
          {
            trigger: 'blur',
            pattern: '^[1-9][0-9]*$',
            message: '年用酒量为正整数',
          },
        ];
      }
      return rowData;
    },
    // 渲染完成后执行
    formComplete() {
      this.disabled(true, ['cityCode', 'districtCode']);
      const provinceCode = this.getRule('provinceCode');
      const cityCode = this.getRule('cityCode');
      const districtCode = this.getRule('districtCode');
      provinceCode.restful = '/mdm/mdmRegionController/selectStartWithProvince';
      provinceCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      provinceCode.props.loading = true;
      provinceCode.props = {
        ...provinceCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };

      provinceCode.on.change = (val) => {
        console.log('porr', val);
        console.log('provinceCode', provinceCode);

        this.setValue({
          city: '',
          district: '',
          province: provinceCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
        if (!val) {
          this.disabled(true, ['cityCode', 'districtCode']);
        } else {
          this.disabled(true, ['districtCode']);
          this.disabled(false, ['cityCode']);
        }
      };

      cityCode.restful = '/mdm/mdmRegionController/list';
      cityCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      cityCode.restfulParamsGetValue = { parentCode: 'provinceCode' };
      cityCode.refresh = true;
      cityCode.props = {
        ...cityCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };
      cityCode.on.change = (val) => {
        this.setValue({
          district: '',
          city: cityCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
        if (!val) {
          this.disabled(true, ['districtCode']);
        } else {
          this.disabled(false, ['districtCode']);
        }
      };
      districtCode.restful = '/mdm/mdmRegionController/list';
      districtCode.optionsKey = { label: 'regionName', value: 'regionCode' };
      districtCode.restfulParamsGetValue = { parentCode: 'cityCode' };
      districtCode.refresh = true;
      districtCode.props = {
        ...districtCode.props,
        loading: true,
        filterable: true,
        remote: true,
        remoteParams: 'regionName',
      };
      districtCode.on.change = (val) => {
        this.setValue({
          district: districtCode.options.find((pitem) => pitem.regionCode === val).regionName,
        });
      };
      console.log('formConfig——————————', this.formConfig);
      const { code, row } = this.formConfig;
      if (code === 'view' || code === 'edit') {
        console.log(1111);
        request.post('/tpm/companyprofile/query', {
          id: row.id,
        }).then((res) => {
          if (res.success) {
            console.log('接口返回', res);
            const { result } = res;
            this.setValue({
              ...result,
            });
          }
        });
      }
    },

    submit(btn) {
      console.log(btn);
      const params = this.getFormData();

      const pars = {
        ...params,
        zcFlag: 'N',
        id: this.formConfig.id || '',
      };
      console.log('pars', pars);

      if (btn === 2) {
        pars.zcFlag = 'Y';
      }
      console.log(params);
      if (params) {
        let path = '';
        if (this.formConfig.id) {
          path = '/tpm/companyprofile/update';
        } else {
          path = '/tpm/companyprofile/save';
        }
        request.post(path, pars).then((res) => {
          if (res.code === 200) {
            this.$message.success('操作成功！');
            this.$emit('onClose');
            this.$emit('onGetList');
          } else {
            this.$message.error(res.messge);
          }
        });
      }
    },
  },
};
